import { ga4Adapter } from './ga4-adapter.js';
import { metaPixelAdapter } from './meta-pixel-adapter.js';

/**
 * Registry of all available destination adapters
 */
const adapters = {
  'GA4': ga4Adapter,
  'META_PIXEL': metaPixelAdapter
  // Future destinations added here
};

/**
 * Get adapter by destination name
 * @param {string} destinationName - Destination name (e.g., "GA4")
 * @returns {DestinationAdapter|null} - Adapter instance or null if not found
 */
export function getAdapter(destinationName) {
  const adapter = adapters[destinationName];

  if (!adapter) {
    console.error(`EventFoundry: Unknown destination "${destinationName}"`);
    return null;
  }

  return adapter;
}

/**
 * Get all registered adapter names
 * @returns {string[]} - Array of destination names
 */
export function getAdapterNames() {
  return Object.keys(adapters);
}
